import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import "./adminHomepage.css";
import axios from "axios";
import { Box, TextField, Button,Typography,Autocomplete, Chip, CircularProgress, MenuItem, AppBar, Toolbar, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel,} from "@mui/material";
import NMH_LOGO_White_RGB from '../../Assets/NMH_LOGO_White_RGB.png';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';

const ReviewPost = () => {
  const [events, setEvents] = useState([]);
  const [categories, setCategories] = useState([]);
  const [sortBy, setSortBy] = useState("");
  const [loading, setLoading] = useState(false);
   const [postingTypes, setPostingTypes] = useState([]);
  const [costs, setCosts] = useState([]);
  const [modes, setModes] = useState([]);
  const [selectedCost, setSelectedCost] = useState("");
  const [selectedMode, setSelectedMode] = useState("");
  const [selectedCategories, setSelectedCategories] = useState([]);
   const [selectedPostingTypes, setSelectedPostingTypes] = useState([]);

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();

  const sortOptions = [
    // { label: "Recently Added", value: "recent" },
    { label: "New to Old", value: "newToOld" },
    { label: "Old to New", value: "oldToNew" },
  ];
 const [enumOptions, setEnumOptions] = useState({
    categories: [],
    costs: [],
    modes: [],
  });
  const [userName, setUsername] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState();
  const [userType, setUserType] = useState("");
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [pendingImageFile, setPendingImageFile] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [pendingDocs, setPendingDocs] = useState([]);
  const [formData, setFormData] = useState({
      hostOrganisation: '',
      eventName: '',
      postStartDate: '',
      postEndDate: '',
      applicationDeadline: '',
      description: '',
       postingTypes: [],
      categories: [],
      cost: '',
      location: '',
      targetGroup: '',
      country: '',
      mode: '',
      hostURL: '',
      eventPosting: '',
      onlineSessionLink: '',
      postedBy: '',
      createdBy: userName,
      yearlyImportant: false,
      attachments:[]
    });
      const handleFormChange = (e) => {
  const { name, value, type, checked } = e.target;
  setFormData((prev) => ({
    ...prev,
    [name]: type === "checkbox" ? checked : value,
  }));
};

  useEffect(() => {
      const fetchEnumOptions = async () => {
        try {
          const response = await axios.get(`${API_BASE_URL}/api/categoryValues`);
          setEnumOptions(response.data);
        } catch (err) {
          console.error('Error fetching enum options:', err);
        }
      };
      fetchEnumOptions();
    }, []);
  const logoutAll = async () => {
  try {
      await axios.post(`${API_BASE_URL}/api/auth/logout`, {}, { withCredentials: true });
      localStorage.clear();
      sessionStorage.clear();

      const googleLogoutWindow = window.open(`https://accounts.google.com/logout`, '_blank');
      setTimeout(() => {
          if (googleLogoutWindow) googleLogoutWindow.close(); 
          navigate('/login'); 
      }, 3000);
  } catch (error) {
      console.error('Logout failed:', error.message);
  }
};
  const handleOpenDialog = (event) => {
    setSelectedEvent(event);
    setFormData(event); 
    setOpenDialog(true);
  };


    const handleCloseDialog = () => {
      setOpenDialog(false);
      setSelectedEvent(null);
      setPendingImageFile(null);
      setPendingDocs([]);
    };
  const fetchPosts = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/api/isLoggedIn`, {
        withCredentials: true,
      });
      if (response.data.username) {
        setUsername(response.data.username);
        setIsLoggedIn(true);
        setUserType(response.data.user);
      } else {
        setIsLoggedIn(false);
        navigate("/login");
      }
        const { user, username } = response.data;
        if (  user === 'Editor' || user === 'Admin') {
        //   setUserType(user);
          setUsername(username);
           const savedRes = await axios.get(`${API_BASE_URL}/api/allreviewevents`);
        // setSavedEvents(savedRes.data);
        setEvents(savedRes.data);
        } 
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    // fetchFilters();
    fetchPosts();
    // getUsernamefromCookie();
  }, []);

const handleSubmit = async (e) => {
  e.preventDefault();
  try {

      let imageUrl = formData.eventImage;
      let pdfUrls = formData.attachments || [];

      if (pendingImageFile) {
        const imgData = new FormData();
        imgData.append("image", pendingImageFile);
        imgData.append('eventName', formData.eventName);
        const res = await axios.post(`${API_BASE_URL}/upload-image`, imgData);
        imageUrl = res.data.imageUrl;
      }

      if (pendingDocs.length > 0) {
        pdfUrls = [];
        for (const file of pendingDocs) {
          const pdfData = new FormData();
          pdfData.append("file", file);
          pdfData.append('eventName', formData.eventName);
          const res = await axios.post(`${API_BASE_URL}/upload-pdf`, pdfData);
          if (res.data.pdfUrl) pdfUrls.push(res.data.pdfUrl);
        }
      }

      const payload = { ...formData, eventImage: imageUrl, attachments: pdfUrls };
    const response = await axios.put(
      `${API_BASE_URL}/api/resubmitevent/${selectedEvent._id}`,
      formData,
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    );
    console.log(formData);
    const savedRes = await axios.get(`${API_BASE_URL}/api/allreviewevents`);
    setEvents(savedRes.data);
    handleCloseDialog();
  } catch (error) {
    console.error('Error submitting event:', error);
  }
};


  return (
    <Box sx={{ width: "100%", padding: 0, margin: 0 }}>
      {
      isLoggedIn
       && userName 
       ? 
      (
        <>
          <div className="form-container-1">
            <Box sx={{ width: "100%", borderColor: "divider" }}>
              <Typography
                sx={{ textAlign: "center", fontWeight: "bold", mb: 1 }}
              >
                Review Events
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  flexWrap: "wrap",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
             {/* <Autocomplete
                multiple
                id="Category"
                options={categories}
                value={selectedCategories} 
                onChange={(event, newValue) => setSelectedCategories(newValue)}
                renderInput={(params) => (
                  <TextField {...params} label="Category" variant="outlined" />
                )}
                sx={{ width: 250 }}
              /> */}

              {/* <Autocomplete
                disablePortal
                id="Cost"
                options={costs}
                value={selectedCost || null}
                onChange={(event, newValue) => setSelectedCost(newValue || "")}
                renderInput={(params) => (
                  <TextField {...params} label="Cost" variant="outlined" />
                )}
                sx={{ width: 250 }}
              />

              <Autocomplete
                disablePortal
                id="Mode"
                options={modes}
                value={selectedMode || null}
                onChange={(event, newValue) => setSelectedMode(newValue || "")}
                renderInput={(params) => (
                  <TextField {...params} label="Mode" variant="outlined" />
                )}
                sx={{ width: 250 }}
              /> */}

                {/* <Autocomplete
                  disablePortal
                  id="SortBy"
                  options={sortOptions}
                  getOptionLabel={(option) => option.label}
                  value={
                    sortOptions.find((opt) => opt.value === sortBy) || null
                  }
                  onChange={(event, newValue) =>
                    setSortBy(newValue ? newValue.value : "")
                  }
                  renderInput={(params) => (
                    <TextField {...params} label="Sort By" variant="outlined" />
                  )}
                  sx={{ width: 250 }}
                /> */}
              </Box>

              {/* <Box
                sx={{
                  padding: 4,
                  display: "flex",
                  gap: 2,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button variant="contained" color="primary" onClick={applyFilters}>
                  Apply Filters
                </Button>
                <Button variant="outlined" onClick={clearSelection}>
                  Clear Selection
                </Button>
              </Box> */}

              {loading ? (
                <div className="loading-container">
                  <CircularProgress />
                </div>
              ) : (
                <Box>
                  <div className="event-list-container">
                    {events.map((event, index) => (
                      <div key={index} className="event-card-horizontal">
                        {/* {event.eventImage ? (
                          <img
                            src={event.eventImage}
                            alt={event.eventName}
                            className="event-thumbnail-homepage"
                          />
                        ) : (
                          <div className="event-thumbnail-homepage" />
                        )} */}

                        <div className="event-content">
                          <Typography
                            variant="h6"
                            className="event-title"
                            // onClick={() => navigate(`/event/${event._id}`)}
                            onClick={() => handleOpenDialog(event)}
                          >
                            {event.eventName}
                          </Typography>
                           <Typography variant="h6" > {event.rejectionReason}</Typography>
                          <Typography variant="body2" className="event-datetime">
                            {new Date(event.postStartDate).toLocaleDateString("en-US", {
                              weekday: "short",
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            })}{" "}
                            · {event.mode}
                          </Typography>
                          <div className="event-tags">
                            {event.categories?.map((type, i) => (
                              <Chip
                                key={i}
                                label={type}
                                className="posting-type-chip"
                                onClick={() => {
                                  setSelectedCategories((prev) => {
                                    if (prev.includes(type)) return prev;
                                    return [...prev, type];
                                  });
                                }}
                                style={{ cursor: "pointer" }}
                              />
                            ))}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </Box>
              )}
            </Box>
          </div>
                {selectedEvent && (
                  <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
                  <DialogTitle>Edit {formData.eventName} </DialogTitle>
                  <DialogContent dividers>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        {pendingImageFile ? (
                          <img
                            src={URL.createObjectURL(pendingImageFile)}
                            alt="Preview"
                            className="category-image"
                            style={{ width: "40%", maxWidth: "100%", alignSelf: "center" }}
                          />
                        ) : (
                          <img
                            src={formData.eventImage}
                            alt="Existing"
                            className="category-image"
                            style={{ width: "40%", maxWidth: "100%", alignSelf: "center" }}
                          />
                        )}
          
                        <Button variant="outlined" component="label" style={{ alignSelf: "center" }}>
                          Replace Image
                          <input
                            type="file"
                            hidden
                            accept="image/*"
                            onChange={(e) => setPendingImageFile(e.target.files[0])}
                          />
                        </Button>
          
                        <Typography variant="subtitle1" className="meta-label">Flyer</Typography>
                        {pendingDocs.length > 0 ? (
                          pendingDocs.map((file, index) => (
                            <Box key={index}>
                              <Typography>{formData.eventName}</Typography>
                            </Box>
                          ))
                        ) : (
                          Array.isArray(formData.attachments) &&
                          formData.attachments.map((url, index) => (
                            <Box key={index}>
                              <a href={url} target="_blank" rel="noopener noreferrer">
                                {formData.eventName} PDF {index + 1}
                              </a>
                            </Box>
                          ))
                        )}
          
                        <Button variant="outlined" component="label">
                          Replace PDFs
                          <input
                            type="file"
                            hidden
                            multiple
                            accept="application/pdf"
                            onChange={(e) => setPendingDocs(Array.from(e.target.files))}
                          />
                        </Button>
          
                      <TextField
                        fullWidth
                        name="hostOrganisation"
                        label="Host Organization"
                        value={formData.hostOrganisation}
                        onChange={handleFormChange}
                      />
                      <TextField
                        fullWidth
                        name="eventName"
                        label="Event Name"
                        value={formData.eventName}
                        onChange={handleFormChange}
                      />
                      <TextField
                        fullWidth
                        name="postStartDate"
                        type="date"
                        label="Post Start Date"
                        InputLabelProps={{ shrink: true }}
                        value={formData.postStartDate?.slice(0, 10) || ""}
                        onChange={handleFormChange}
                      />
                      <TextField
                        fullWidth
                        name="postEndDate"
                        type="date"
                        label="Post End Date"
                        InputLabelProps={{ shrink: true }}
                        value={formData.postEndDate?.slice(0, 10) || ""}
                        onChange={handleFormChange}
                      />
                      <TextField
                        fullWidth
                        name="applicationDeadline"
                        type="date"
                        label="Application Deadline"
                        InputLabelProps={{ shrink: true }}
                        value={formData.applicationDeadline?.slice(0, 10) || ""}
                        onChange={handleFormChange}
                      />
                      <TextField
                        fullWidth
                        name="description"
                        label="Description"
                        multiline
                        rows={3}
                        value={formData.description}
                        onChange={handleFormChange}
                      />
          
                      <Autocomplete
                        multiple
                        options={enumOptions.categories}
                        getOptionLabel={(option) => option || ''}
                        value={formData.categories}
                        onChange={(event, newValue) =>
                          setFormData((prev) => ({ ...prev, categories: newValue }))
                        }
                        renderInput={(params) => <TextField {...params} label="Categories" />}
                      />
          
                      {/* <Autocomplete
                        multiple
                        options={enumOptions.postingTypes}
                        getOptionLabel={(option) => option || ''}
                        value={formData.postingTypes}
                        onChange={(event, newValue) =>
                          setFormData((prev) => ({ ...prev, postingTypes: newValue }))
                        }
                        renderInput={(params) => <TextField {...params} label="Posting Types" />}
                      /> */}
          
                      <Autocomplete
                        options={enumOptions.costs}
                        getOptionLabel={(option) => option || ''}
                        value={formData.cost}
                        onChange={(event, newValue) =>
                          setFormData((prev) => ({ ...prev, cost: newValue }))
                        }
                        renderInput={(params) => <TextField {...params} label="Cost" />}
                      />
          
                      <Autocomplete
                        options={enumOptions.modes}
                        getOptionLabel={(option) => option || ''}
                        value={formData.mode}
                        onChange={(event, newValue) =>
                          setFormData((prev) => ({ ...prev, mode: newValue }))
                        }
                        renderInput={(params) => <TextField {...params} label="Mode" />}
                      />
          
                      <TextField
                        fullWidth
                        name="location"
                        label="Location"
                        value={formData.location}
                        onChange={handleFormChange}
                      />
                      <TextField
                        fullWidth
                        name="targetGroup"
                        label="Target Group"
                        value={formData.targetGroup}
                        onChange={handleFormChange}
                      />
                      <TextField
                        fullWidth
                        name="country"
                        label="Country"
                        value={formData.country}
                        onChange={handleFormChange}
                      />
                       {/* <TextField
                        fullWidth
                        name="country"
                        label="Country"
                        value={formData.eventImage}
                        onChange={handleFormChange}
                      /> */}
                    
                      <TextField
                        fullWidth
                        name="hostURL"
                        label="URL"
                        value={formData.hostURL}
                        onChange={handleFormChange}
                      />
                      {/* <TextField
                        fullWidth
                        name="eventPosting"
                        label="Event Posting"
                        value={formData.eventPosting}
                        onChange={handleFormChange}
                      /> */}
                      <TextField
                        fullWidth
                        name="onlineSessionLink"
                        label="Online Meeting Link"
                        value={formData.onlineSessionLink}
                        onChange={handleFormChange}
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="yearlyImportant"
                            checked={formData.yearlyImportant}
                            onChange={handleFormChange}
                          />
                        }
                        label="Recurring event"
                      />
          
                 
          
                    </Box>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleCloseDialog} color="secondary">
                      Cancel
                    </Button>
                    {/* <Button onClick={handleSave} color="primary">
                       Save 
                    </Button> */}
                    <Button onClick={handleSubmit} color="primary">
                       Re-Submit
                    </Button>
                  </DialogActions>
                </Dialog>
                
          
                )}
        </>
      ) : (
        <h4>Checking authentication...</h4>
      )}
    </Box>
  );
};

export default ReviewPost;